import React from "react"
//************************************//
import {humanizeDate, toLocalDateFormat} from '@utils'
//************************************//
const HumanizeDate = ({date, isUtc = true, someElseFormat = 'L'}) => {
  return (
    <span title={toLocalDateFormat(date, 'LLL', isUtc)}>
      {humanizeDate(date, isUtc, someElseFormat)}
    </span>
  )
}

export default HumanizeDate